import React from 'react';
import { Box, Link, VStack } from '@chakra-ui/react';
import { useTranslationsContext } from './useTranslations';

interface SkipLinksProps {
  links?: Array<{
    href: string;
    label: string;
  }>;
}

const useDefaultLinks = () => {
  const t = useTranslationsContext();

  return [
    { href: '#main-content', label: t.skip_to_main_content },
    { href: '#navigation', label: t.skip_to_navigation },
    { href: '#footer', label: t.skip_to_footer }
  ];
};

export const SkipLinks: React.FC<SkipLinksProps> = ({ links }) => {
  const defaultLinks = useDefaultLinks();
  return (
    <Box
      position="fixed"
      top="-200px"
      left="20px"
      zIndex={9999}
      _focusWithin={{
        top: "20px"
      }}
      bg="white"
      border="2px solid"
      borderColor="blue.500"
      borderRadius="md"
      p={2}
      boxShadow="lg"
      transform="translateY(0)"
      transition="all 0.3s ease"
    >
      <VStack spacing={1} align="stretch">
        {(links ?? defaultLinks).map((link, index) => (
          <Link
            key={index}
            href={link.href}
            px={3}
            py={2}
            bg="brand"
            color="white"
            borderRadius="md"
            textDecoration="none"
            fontSize="sm"
            fontWeight="medium"
            _hover={{
              bg: "red.600",
              textDecoration: "none"
            }}
          >
            {link.label}
          </Link>
        ))}
      </VStack>
    </Box>
  );
};

export default SkipLinks;
